import { MaxBreakPoints } from "../style/constants";
import { useWindowSize } from "./useWindowSize";

export const useIsMobile = () => {
  const { width } = useWindowSize();
  return width <= MaxBreakPoints.MEDIUM;
};
